/* eslint-disable import/no-named-as-default-member */
import i18next from 'i18next';

export function translateError(error) {
  let errorKey;

  // Use the plain error message from the backend response, removing any colon characters
  if (error?.response?.data?.error?.message) {
    errorKey = error.response.data.error.message.replace(/:/g, '');
  } else if (typeof error === 'object' && error.message) {
    errorKey = error.message.replace(/:/g, '');
  } else if (typeof error === 'string') {
    errorKey = error.replace(/:/g, '');
  }

  if (errorKey) {
    const translation = i18next.t(`error.${errorKey}`);
    return translation;
  } else {
    console.log('No errorKey found, returning generic translation');
    return i18next.t('error.generic');
  }
}
